const modulesConfig = [
  {
    name: "Sales",
    permissions: [
      { id: "NewSales", label: "New Sales" },
      { id: "SalesHistory", label: "Sales History" },
      { id: "HoldList", label: "Hold List" },
      { id: "POS", label: "POS" },
      { id: "SalesQuickOrder", label: "Sales Quick Order" },
      { id: "Promotion", label: "Promotion" },
    ],
  },
  {
    name: "Picking",
    permissions: [
      { id: "CreatePicking", label: "Create Picking" },
      { id: "PickingList", label: "Picking List" },
      { id: "PickingHistory", label: "Picking History" },
      { id: "ShortQTY", label: "Short QTY" },
      { id: "ProformaInvoice", label: "Proforma Invoice" },
    ],
  },
  {
    name: "Delivery & Dispatch",
    permissions: [
      { id: "CreateManifest", label: "Create Manifest" },
      { id: "ManifestList", label: "Manifest List" },
      { id: "Trip", label: "Trip" },
    ],
  },
  {
    name: "Returns",
    permissions: [
      { id: "ReturnList", label: "Return List" },
    ],
  },
  {
    name: "Purchases",
    permissions: [
      { id: "PurchasesOrder", label: "Purchases Order" },
      { id: "PurchasesHistory", label: "Purchases History" },
      { id: "StockAdjustment", label: "Stock Adjustment" },
    ],
  },
  {
    name: "Account",
    permissions: [
      { id: "Push-to-Sage", label: "Push to Sage" },
      { id: "AllPushInvoice", label: "All Push Invoice" },
      { id: "ReceivedPayments", label: "Received Payments" },
      { id: "CustomerAccount", label: "Customer Account" },
      { id: "PaymentLedger", label: "Payment Ledger" },
      { id: "MyLedger", label: "My Ledger" },
      { id: "BankLedger", label: "Bank Ledger" },
    ],
  },
  {
    name: "Master",
    permissions: [
      { id: "Product", label: "Product" },
      { id: "ProductsPriceVariation", label: "Products Price Variation" },
      { id: "Customers", label: "Customers" },
      { id: "Supplier", label: "Supplier" },
      { id: "Users", label: "Users" },
      { id: "RoleAssign", label: "Role Assign" },
      { id: "ProductCategories", label: "Product Categories" },
      { id: "Brand", label: "Brand" },
      { id: "Unit", label: "Unit" },
      { id: "CreditFacility", label: "Credit Facility" },
      { id: "Adjustments", label: "Adjustments" },
      { id: "StockTake", label: "Stock Take" },
      { id: "OrderProductDiscount", label: "Order and Product Discount" },
      { id: "Catalogue", label: "Catalogue" },
      { id: "Amazon Product List", label: "Amazon Product List" },
      { id: "Shopify Product List", label: "Shopify Product List" },
    ],
  },
  {
    name: "Reports",
    permissions: [
      { id: "CustomernotOrder", label: "Customer not Order" },
      { id: "DriverReport", label: "Driver Report" },
      { id: "InventorySales", label: "Inventory Sales" },
      { id: "MISreport", label: "MIS report" },
      { id: "Cross-Off", label: "Cross-Off" },
      { id: "Sales-Rep", label: "Sales-Rep" },
      { id: "ProfitLoss", label: "Profit and Loss" },
    ],
  },
  {
    name: "Slider",
    permissions: [
      { id: "Show", label: "Show" },
    ],
  },
  {
    name: "Promotion",
    permissions: [
      { id: "Catalogue", label: "Catalogue" },
      { id: "SliderSettings", label: "Slider Settings" },
      { id: "Promotions", label: "Promotions" },
      { id: "EmailTemplate", label: "Email Template" },
    ],
  },
];

export default modulesConfig; 